import { HttpErrorResponse } from "@angular/common/http";
import { ErrorHandler, Inject, Injectable, Injector } from "@angular/core";
import { MainStore } from "./common/main.store";
import { Router } from "@angular/router";

@Injectable()    
export class AppErrorHandler extends ErrorHandler {
    constructor(
        @Inject(Injector) private readonly injector: Injector
    ) {
        super();
    }

    override handleError(error: any) {

        // Check if it's an error from an HTTP response
        if ((error instanceof HttpErrorResponse)) {
            error = error?.error || error?.message || error?.statusText || 'Undefined client error';
            this.store.error.set(error);
        }

        super.handleError(error);
    }

    private get store(): MainStore {
        return this.injector.get(MainStore);
    }

    private get router(): Router {
        return this.injector.get(Router);
    }
}